import { createFileRoute } from '@tanstack/react-router'
import { useCurrentAssistant, useThread } from '~/api'
import { AppDisabled } from '~/components/student/app/AppDisabled'
import { Messages } from '~/components/student/chat/Messages'

export const Route = createFileRoute('/student/courses/$courseId/apps/$appId/threads/$threadId')({
	component: Thread,
})

function Thread() {
	const { data: thread } = useThread()
	const assistant = useCurrentAssistant()

	if (assistant != null && !assistant.isAvailableAndEnabledForRole) {
		return <AppDisabled />
	}

	return (
		<>
			<Messages messages={thread?.uiMessages} />
		</>
	)
}
